import React, { Component } from "react";
import IGetProductSearchesByCustomerReportDTO from "../../../../models/DTO/IGetProductSearchesByCustomerReportDTO";
import IOnGetProductSearchesByCustomerReportDTO from "../../../../models/DTO/IOnGetProductSearchesByCustomerReportDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import ISearch from "../../../../models/ISearch";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import ReportPeriodType from "../../../../models/ReportPeriodTypeEnum";
import ReportTypeEnum from "../../../../models/ReportTypeEnum";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import * as _ from "lodash-es";
import "./ProductSearchesByCustomerReport.scss";
import IProcessed_Report from "../../../../models/IProcessed_Report";
import ReportPeriod from "../ReportPeriod/ReportPeriod";

type Props = {
    processedReport: IProcessed_Report;
};

type State = {
    vendors: string[];
    vendorDictionary: { [key: string]: ISearch[] };
};

export default class ProductSearchesByCustomerReport extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            vendors: [],
            vendorDictionary: {},
        };
    }

    componentDidMount(): void {
        this.onProductSearchesByCustomer(this.props.processedReport.report_data);
    }

    componentWillUnmount(): void {}

    onProductSearchesByCustomer = (data: IOnGetProductSearchesByCustomerReportDTO) => {
        for (const vendor of Object.keys(data.vendors)) {
            data.vendors[vendor] = _.sortBy(data.vendors[vendor], (search: ISearch) => {
                return search.search_term;
            });
        }

        this.setState({
            vendors: Object.keys(data.vendors),
            vendorDictionary: data.vendors,
        });
    };

    render() {
        return (
            <div className={"ProductSearchesByCustomerReport"}>
                <div className="row">
                    <OwTitle className={"col-12"} title={"product_searches_by_customer_report"} />
                    <ReportPeriod
                        className={"col-12 mb-3"}
                        startDate={this.props.processedReport.period_start}
                        endDate={this.props.processedReport.period_end}
                    />
                </div>

                <div className="row">
                    <div className="col-12 d-flex flex-column">
                        {this.state.vendors.map((vendor, index) => {
                            return (
                                <div key={index}>
                                    {vendor === "blank" ? (
                                        <OwTitle title={"general_searches"} tag={"h3"} />
                                    ) : (
                                        <OwTitle title={vendor} disableTranslation={true} tag={"h3"} />
                                    )}
                                    <div className={""}>
                                        {this.state.vendorDictionary[vendor].map((search) => {
                                            return (
                                                <div key={search.guid} className={"ms-2"}>
                                                    {search.search_term}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}
